module.exports = __webpack_public_path__ + "img/microsilver_mouthwash.76835695.jpg";